import { useState, useEffect } from 'react'
import { Disclosure } from '@headlessui/react'
import { IconChevronDown } from '@tabler/icons-react'

export const SectionTitle = ({
  title,
  children,
}: {
  title: string
  children?: React.ReactNode
}) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (!isMobile) {
    return (
      <>
        <h2 className="mt-4 border-l-4 border-toasty-blue-500 pl-3 font-jakarta text-lg font-semibold text-gray-900">
          {title}
        </h2>
        {children}
      </>
    )
  }

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <>
          <Disclosure.Button className="mt-4 flex w-full items-center justify-between border-l-4 border-toasty-blue-500 pl-3">
            <h2 className="font-jakarta text-lg font-semibold text-gray-900">
              {title}
            </h2>
            <IconChevronDown
              className={`${
                open ? 'rotate-180 transform' : ''
              } h-5 w-5 text-gray-500 transition-transform duration-200`}
            />
          </Disclosure.Button>
          <Disclosure.Panel>{children}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
